<template>
  <el-dialog
    :title="`物流单号：${config.courierNumber}`"
    :visible.sync="visible"
    width="720px"
    append-to-body
    @closed="handleClosed">
    <el-steps
      v-if="traces.length > 0"
      v-loading="loading"
      direction="vertical"
      :active="traces.length - 1">
      <el-step
        v-for="(item, index) in traces"
        :key="index"
        :title="item.AcceptTime">
        <div slot="description">
          <div>{{ item.AcceptStation }}</div>
          <div v-if="item.Remark">备注：{{ item.Remark || '-' }}</div>
        </div>
      </el-step>
    </el-steps>
    <empty
      v-else
      content="暂无物流信息"
      tip="暂无物流信息哦~" />
    <div slot="footer">
      <el-button
        :loading="loading"
        type="primary"
        @click="refresh">刷新</el-button>
      <el-button
        :loading="loading"
        @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'DeliveryTraceModal',
  components: { },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      visible: false,
      traces: [],
      config: {
        vendorId: null,
        courierNumber: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.traces = []
      this.config.vendorId = null
      this.config.courierNumber = null
    },
    refresh() {
      this.fetchList()
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('vendor/getdeliverytrace', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.traces = res.data.traces || []
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(row) {
      this.config = {
        ...this.config,
        ...row
      }
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
